import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-feedback-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './feedback-card.html',
  styleUrls: ['./feedback-card.css']
})
export class FeedbackCardComponent {
  @Input() isVisible: boolean = false;
  @Input() feedbackType: 'positive' | 'negative' = 'positive';
  @Output() feedbackSubmitted = new EventEmitter<any>();
  @Output() feedbackClosed = new EventEmitter<void>();
  @Output() feedbackSuccess = new EventEmitter<void>();

  stars: number[] = [1, 2, 3, 4, 5];
  rating = 0;
  additionalFeedback: string = '';
  showValidation = false;

  setRating(value: number): void {
    this.rating = value;
  }

  submitFeedback(): void {
    this.showValidation = true;

      if (this.rating === 0 || !this.additionalFeedback.trim()) {
        return;
      }

    const feedback = {
      isLiked: this.rating >= 4,
      comment: this.createComment()
    };

    this.feedbackSubmitted.emit(feedback);
    this.feedbackSuccess.emit();
    this.closeFeedback();
  }

  private createComment(): string {
    const message = this.additionalFeedback.trim();
    if (message) {
      return `Rating: ${this.rating}/5. Feedback: ${message}`;
    }
    return `Rating: ${this.rating}/5`;
  }

  closeFeedback(): void {
    this.isVisible = false;
    this.rating = 0;
    this.additionalFeedback = '';
    this.showValidation = false;
    this.feedbackClosed.emit();
  }
}
